import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { useRef } from 'react';
import { useOptionContextStabilizer, useOption } from '@mui/base';
import { ListContext } from '@mui/base/useList';
import { unstable_useForkRef } from '@mui/utils';
import classnames from 'classnames';
import { CheckmarkToggleIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';

var InnerOption = /*#__PURE__*/React.forwardRef(function (_a, forwardedRef) {
  var _b;
  var children = _a.children,
    className = _a.className,
    _a$disabled = _a.disabled,
    disabled = _a$disabled === undefined ? false : _a$disabled,
    label = _a.label,
    value = _a.value,
    props = __rest(_a, ["children", "className", "disabled", "label", "value"]);
  var optionRef = useRef(null);
  var combinedRef = unstable_useForkRef(optionRef, forwardedRef);
  var computedLabel = label !== null && label !== undefined ? label : typeof children === 'string' ? children : (_b = optionRef.current) === null || _b === undefined ? undefined : _b.innerText;
  var _useOption = useOption({
      disabled: disabled,
      label: computedLabel,
      rootRef: combinedRef,
      value: value
    }),
    getRootProps = _useOption.getRootProps,
    highlighted = _useOption.highlighted,
    selected = _useOption.selected;
  return jsxs("li", Object.assign({}, getRootProps(), {
    className: classnames('cogs-lab-select-option', highlighted && 'cogs-lab-select-option--highlighted', selected && 'cogs-lab-select-option--selected', className)
  }, props, {
    children: [jsx(IconWrapper, {
      className: "cogs-lab-select-option-selected-icon",
      size: 16,
      children: selected && jsx(CheckmarkToggleIcon, {})
    }), jsx("div", {
      className: classnames('cogs-lab-select-option-label'),
      children: children
    })]
  }));
});
var Option = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value;
  var _useOptionContextStab = useOptionContextStabilizer(value),
    contextValue = _useOptionContextStab.contextValue;
  return jsx(ListContext.Provider, {
    value: contextValue,
    children: jsx(InnerOption, Object.assign({}, props, {
      ref: ref
    }))
  });
});

export { Option };
